export class FilterFieldType
{
    name: string;
    type: string;
    operator?: string;
}
